<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <section
    class="check-cases"
    [class.border]="data.standard_1205.isApplicable"
    [attr.id]="data.standard_1205.title"
  >
    <mat-slide-toggle
      [color]="data.standard_1205.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.standard_1205.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.standard_1205.isApplicable && !data.standard_1205.isPassed
        "
        >{{ data.standard_1205.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.standard_1205.isApplicable && !data.standard_1205.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.standard_1205.title }}
    </span>
    <div class="cases" *ngIf="data.standard_1205.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205.systemInstallationAccordingSpec"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.standard_1205.waterSupplyPipesInstallationAccordingSpec
        "
      ></authority-labs-check-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="data.standard_1205_part_1.isApplicable"
    [attr.id]="data.standard_1205_part_1.title"
  >
    <mat-slide-toggle
      [color]="data.standard_1205_part_1.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.standard_1205_part_1.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.standard_1205_part_1.isApplicable &&
          !data.standard_1205_part_1.isPassed
        "
        >{{ data.standard_1205_part_1.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.standard_1205_part_1.isApplicable &&
        !data.standard_1205_part_1.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.standard_1205_part_1.title }}
    </span>
    <div class="cases" *ngIf="data.standard_1205_part_1.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.drinkingWaterSystem"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.standard_1205_part_1.waterPipeInstallationAccordingSpec
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.hangingPointsGaps"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.verticalTube"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.waterSupplyPipesPassage"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.sealingConnections"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.galvanizedSteelPipes"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.corrosionProtectedThread"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.plumbingMmadeOfSteel"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.galvanizedScrewedUpAbsorbers"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.standard_1205_part_1.galvanizedSteelPipesAccordingToStandard
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.standard_1205_part_1.pipeNominalDiameterForSingleFireHydrant
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.standard_1205_part_1.pipeNominalDiameterForMultiFireHydrants
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.pipeNominalDiameterForCartwheel"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.fireHydrantIsMarked"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.waterSupplyForFireExtinguishing"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.standard_1205_part_1.drinkingWaterSupplyNetworkConnection
        "
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.onlyMetalPipesInstalled"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.closingValvesSigns"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.fireHydrantExist"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.twoHosesExist"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.multipurposeJumperExist"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.EquipmentApproved"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.rubberTube"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.multipurposeLeaper"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_1.ballOpeningTap"
      ></authority-labs-check-case>
    </div>
  </section>

  <section
    class="check-cases"
    [class.border]="data.standard_1205_part_6.isApplicable"
    [attr.id]="data.standard_1205_part_6.title"
  >
    <mat-slide-toggle
      [color]="data.standard_1205_part_6.isPassed ? 'primary' : 'warn'"
      [(ngModel)]="data.standard_1205_part_6.isApplicable"
      (change)="onDataChange()"
      *ngIf="!(readonly || printPreview)"
    >
      <span
        class="title"
        [class.error]="
          data.standard_1205_part_6.isApplicable &&
          !data.standard_1205_part_6.isPassed
        "
        >{{ data.standard_1205_part_6.title }}</span
      >
    </mat-slide-toggle>
    <span
      class="title"
      [class.error]="
        data.standard_1205_part_6.isApplicable &&
        !data.standard_1205_part_6.isPassed
      "
      *ngIf="readonly || printPreview"
      >{{ data.standard_1205_part_6.title }}
    </span>
    <div class="cases" *ngIf="data.standard_1205_part_6.isApplicable">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.standard_1205_part_6.plumbingPassedOpacityTest"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="
          data.standard_1205_part_6.systemComponentsDescriptionPassed
        "
      ></authority-labs-check-case>
    </div>
  </section>

  <authority-labs-water-network-characterization-inspection
    [waterNetworkData]="data.waterNetworkCharacterization"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onDataChange()"
  >
  </authority-labs-water-network-characterization-inspection>
</main>
